import { CONFIG } from 'app/core/config';
import { Unit } from 'app/viewmodels/unit';
import { ViewModel } from 'app/viewmodels/view-model';
import { TableItemState } from '../../../component-library/table/table-item-state.enum';
import { TableTemplate } from '../table-attribute-template/table-template';
import { HierarchyTemplate } from './hierarchy-template';
import { TemplateAttributeDataType } from './template-attribute-data-type.enum';

export class HierarchyTemplateAttribute implements ViewModel {
  public readonly friendlyTypeNameSingular: string = 'Hierarchy Template Attribute';
  public readonly apiRoute: string = CONFIG.apiRoutes.hierarchyTemplateAttributes;

  public hierarchyTemplateAttributeId: string;
  public name: string;
  public dataType: TemplateAttributeDataType;
  public uomId: string;
  public uom: Unit;
  public tabName: string;
  public groupName: string;
  public hierarchyTemplateId: string;
  public hierarchyTemplate: HierarchyTemplate;
  public sourceLookupId: string;
  public masterAttributeId: string;
  public lockedAttributes: boolean;
  public state: TableItemState = TableItemState.Unchanged;
  public refId: string;
  public hierarchyTemplateGroupId: string;
  public rowNumber: number;
  public tableTemplateId: string;
  public tableTemplate: TableTemplate;

  public json(): HierarchyTemplateAttribute {
    return this;
  }

  public loadFromJson(data): void {
    this.hierarchyTemplateAttributeId = data.hierarchyTemplateAttributeId;
    this.name = data.name;
    this.dataType = data.dataType;
    this.uomId = data.uomId;

    if (data.unit) {
      this.uom = new Unit();
      this.uom.loadFromJson(data.unit);
    }

    if (data.hierarchyTemplate) {
      this.hierarchyTemplate = data.hierarchyTemplate;
    }

    if (data.tableTemplate) {
      this.tableTemplate = new TableTemplate();
      this.tableTemplate.loadFromJson(data.tableTemplate);
    }

    this.tabName = data.tabName;
    this.groupName = data.groupName;
    this.hierarchyTemplateId = data.hierarchyTemplateId;
    this.sourceLookupId = data.sourceLookupId;
    this.masterAttributeId = data.masterAttributeId;
    this.lockedAttributes = data.lockedAttributes;
    this.hierarchyTemplateGroupId = data.hierarchyTemplateGroupId;
    this.rowNumber = data.rowNumber;
    this.tableTemplateId = data.tableTemplateId;
  }
}
